import React, { useMemo } from 'react';

import { AgGridReact } from 'ag-grid-react';
import cs from 'classnames';

import ToggleSwitch from 'components/shared/ToggleSwitch/ToggleSwitch';
import Typography from 'components/shared/Typography/Typography';

import TableFilters from '../components/TableFilters';
import TablePagination from '../components/TablePagination';

const EmptyServicesState = () => (
  <div className="flex h-full w-full flex-col items-center justify-center py-12">
    <Typography weight="semibold" className="mb-1 text-neutral-800">
      No services found
    </Typography>
    <Typography className="text-neutral-500">
      Try adjusting your filters or specialty selection.
    </Typography>
  </div>
);

const ServicesTable = ({
  columnDefs,
  tabsData,
  selectedSpecialty,
  onSpecialtyChange,
  filters,
  onFilterChange,
  showControls,
  onColumnChange,
  onColumnDragEnd,
  paginatedAndFilteredData,
  gridApi,
  onGridReady,
  onSelectionChanged,
  page,
  limit,
  totalItems,
  onPageChange,
  onLimitChange,
  isLoading
}) => {
  const defaultColDef = useMemo(
    () => ({
      flex: 1,
      minWidth: 100,
      resizable: true
    }),
    []
  );

  return (
    <div className="flex h-full min-h-0 w-full flex-col overflow-hidden rounded-lg border border-solid border-neutral-200">
      <div className="flex-shrink-0 border-0 border-b border-solid border-neutral-200 bg-white px-3 py-2">
        <ToggleSwitch
          items={tabsData}
          active={selectedSpecialty}
          onClick={(item) => onSpecialtyChange(item.value)}
        />
      </div>

      {showControls && (
        <div className="flex-shrink-0">
          <TableFilters
            filters={filters}
            changeFilters={onFilterChange}
            columnDefs={columnDefs}
            onColumnChange={onColumnChange}
            onColumnDragEnd={onColumnDragEnd}
          />
        </div>
      )}

      <div className={cs('ag-theme-quartz min-h-0 flex-1 overflow-auto', isLoading && 'opacity-50')}>
        <AgGridReact
          columnDefs={columnDefs}
          rowData={paginatedAndFilteredData}
          defaultColDef={defaultColDef}
          onGridReady={onGridReady}
          onSelectionChanged={onSelectionChanged}
          getRowId={(params) => params.data.code}
          rowSelection="multiple"
          noRowsOverlayComponent={EmptyServicesState}
          suppressRowClickSelection={true}
          domLayout="autoHeight"
        />
      </div>

      {showControls && (
        <div className="flex-shrink-0">
          <TablePagination
            page={page}
            limit={limit}
            totalItems={totalItems}
            setLimit={onLimitChange}
            setPage={onPageChange}
            onPageChange={onPageChange}
          />
        </div>
      )}
    </div>
  );
};

export default ServicesTable;
